import { Link } from 'react-router-dom';
import './Footer.css';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="footer">
            <p className="footerTagline">
                Admire the possibilities.
            </p>

            <div className="footerGrid">
                <div className="footerSection">
                    <p className="footerSectionTitle">Context</p>
                    <Link to="/about" className="footerLink">About</Link>
                    <Link to="/contact" className="footerLink">Contact</Link>
                </div>

                <div className="footerSection">
                    <p className="footerSectionTitle">Site</p>
                    <Link to="/" className="footerLink">Index</Link>
                </div>

                <div className='footerSection'>
                    <p className="footerSectionTitle">Link</p>
                    <div className="footerSocial">

                        <a href="https://www.instagram.com/lurscript">
                            <FaInstagram className="instagramIcon" />
                            
                        </a>

                        <a href="https://www.linkedin.com/company/lurscript">
                            <FaLinkedin className="linkedinIcon" />
                        </a>
                    
                    </div>
                </div>
            </div>

            <p className="footerCopyright">&copy; 2026 Lurscript. All rights reserved.</p>


        </footer>
    );
}

export default Footer;
